// src/components/BubblePack.jsx
import React, { useMemo } from "react";
import * as d3 from "d3";

/**
 * data: [{ name: '500036', value: 12, ANDROID: 8, IOS: 4 }, ...]
 * width, height: numbers (container size)
 * padding: number (bubble spacing)
 * colorFn: (d) => string (optional), gets full datum
 * onBubbleClick: (d) => void (optional)
 */
const BubblePack = ({ data, width = 500, height = 500, padding = 4, colorFn, onBubbleClick }) => {
  const root = useMemo(() => {
    return d3
      .hierarchy({ children: data })
      .sum(d => d.value || 0)
      .sort((a, b) => (b.value || 0) - (a.value || 0));
  }, [data]);

  const nodes = useMemo(() => {
    const pack = d3.pack().size([width, height]).padding(padding);
    return pack(root).leaves();
  }, [root, width, height, padding]);

  return (
    <svg width={width} height={height} className="block">
      {nodes.map((node, i) => {
        const d = node.data; // {name, value, ANDROID, IOS}
        const fill = colorFn ? colorFn(d) : "#336fcc"; // default DriveEasy blue
        return (
          <g
            key={i}
            transform={`translate(${node.x},${node.y})`}
            className="cursor-pointer"
            onClick={() => onBubbleClick && onBubbleClick(d)}
          >
            <title>
              {`Pincode: ${d.name}\nTotal: ${d.value}\nAndroid: ${d.ANDROID || 0}\niOS: ${d.IOS || 0}`}
            </title>
            <circle
              r={node.r}
              fill={fill}
              // subtle dark-mode aware outline
              className="stroke-white dark:stroke-neutral-900"
              strokeWidth={2}
            />
            <text
              textAnchor="middle"
              dy="0.35em"
              fill="#fff"
              fontSize={Math.min(node.r / 3, 14)}
              style={{ pointerEvents: "none" }}
            >
              {d.name}
            </text>
          </g>
        );
      })}
    </svg>
  );
};

export default BubblePack;
